module.exports = __webpack_public_path__ + "static/img/1.2bd73c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/zh/1.png
// module id = VLcK
// module chunks = 0